<ng-container *ngrxLet="hasSubscription$; let hasSubscription">
  <mat-horizontal-stepper class="payment-wizard" linear #stepper [selectedIndex]="selectedIndex$ | ngrxPush"
    (selectionChange)="selectionChange($event, stepper)">
    <mat-step [completed]="priceComplete$ | ngrxPush">
      <ng-template matStepLabel>pricing</ng-template>
      <button class="btn-get-started" color="primary" mat-flat-button matStepperNext>
        GET STARTED
      </button>
      <spt-pricing-wide class="push-top-20"></spt-pricing-wide>
      <button class="btn-get-started" color="primary" mat-flat-button matStepperNext>
        GET STARTED
      </button>
    </mat-step>

    <mat-step [completed]="createAccountComplete$ | ngrxPush">
      <ng-template matStepLabel><span *ngIf="!hasSubscription">create</span> account</ng-template>
      <div class="center-wizard-content">
        <mat-card>
          <mat-card-content>
            <spt-login [signInWithPopup]="true"></spt-login>
          </mat-card-content>
          <mat-card-actions>
            <button mat-flat-button color="primary" matStepperNext type="button"
              [disabled]="!(createAccountComplete$ | ngrxPush)">
              Next
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
    </mat-step>

    <!--    <mat-step *ngIf="hasSubscription">-->
    <!--      <ng-template matStepLabel>change subscription</ng-template>-->
    <!--      <div class="mat-h2">My Subscription</div>-->
    <!--      <spt-my-subscription></spt-my-subscription>-->
    <!--    </mat-step>-->

    <mat-step>
      <mat-progress-bar *ngIf="payment.showCheckoutProgress$ | ngrxPush" class="subscribe-progress-bar" color="accent"
        mode="indeterminate"></mat-progress-bar>
      <!--   TODO UPDATE   -->
      <!--      <ng-container *ngIf="payment.cancelAtPeriodEnd$ | ngrxPush">-->
      <!--        <spt-subscription-end-->
      <!--          [subscription]="-->
      <!--            payment.selectCurrentSubscription$ | ngrxPush-->
      <!--          "></spt-subscription-end>-->
      <!--      </ng-container>-->

      <ng-template matStepLabel>
        <span *ngIf="!hasSubscription">select a plan</span>
        <span *ngIf="hasSubscription">update plan</span>
      </ng-template>

      <div class="subscribe-panels">
        <div class="mat-elevation-z2 column plans">
          <!--<div class="subscribe-trial" *ngIf="!(hasSubscription$ | ngrxPush)">
            <span class="accent subscribe-trial-bold"
              >For 7 Day Trial, just download the app and start using
              it.</span
            >
            Free account required.
          </div>-->
          <div class="mat-h4 primary">SELECT PLAN</div>
          <mat-radio-group [formControl]="planPriceIDForm" class="example-radio-group price-tile-container"
            aria-label="Select an option">
            <ng-container *ngrxLet="productsWithPricesCurrentSubscription$; let products">
              <ng-container *ngFor="let p of products">
                <div class="price-tile">
                  <div class="mat-h3">{{ p.product.name }}</div>
                  <div class="subheading-2">
                    Includes
                    {{ p.product.metadata.baseStorageGB }} GB Storage
                  </div>
                  <ng-container *ngFor="let o of p.prices">
                    <mat-radio-button value="{{ o.price.id }}">
                      {{ formatCurrency(o.price) }} /
                      {{ o.price.interval }}
                      <span *ngIf="o.isCurrentSubscriptionPrice" class="accent">
                        ( Current Subscription )
                      </span>
                    </mat-radio-button>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </mat-radio-group>
        </div>

        <div class="mat-elevation-z2 column addons">
          <div class="mat-h4 primary additional-storage">
            ADDITIONAL STORAGE
          </div>
          <spt-addon-storage (priceChange)="payment.updatePrice($event)" (quantityChange)="
              payment.updateStorageQty($event)
            "></spt-addon-storage>
        </div>

        <div class="mat-elevation-z2 column itemized">
          <div class="mat-h4 primary">SUMMARY</div>
          <div>
            <table mat-table [dataSource]="subscriptionItemized">
              <ng-container matColumnDef="itemName">
                <!--                <th mat-header-cell *matHeaderCellDef>SubscriptionItem</th>-->
                <td mat-cell *matCellDef="let element" class="item-name">
                  {{ element.itemName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="itemPrice">
                <!--                <th mat-header-cell *matHeaderCellDef>Cost</th>-->
                <td mat-cell *matCellDef="let element" class="item-price">
                  <span *ngIf="!element.isIncludedStorage">
                    {{ element.itemPrice | currency }}
                  </span>
                  <span *ngIf="element.isIncludedStorage">Included</span>
                </td>
              </ng-container>

              <!--              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>-->
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <div class="total-cost">
              <div>Total</div>
              <div>
                {{ payment.totalCost$ | ngrxPush | currency: "USD" }}
                <span class="time-period">
                  /
                  {{
                  (payment.isPerMonth$ | ngrxPush) ? "month" : "year"
                  }}</span>
              </div>
            </div>
          </div>

          <div class="early-adopter-agreement-checkbox" *ngIf="payment.getEarlyAdopterSelected$ | ngrxPush">
            <mat-checkbox (change)="payment.signEarlyAdopterAgreement($event.checked)"
              [checked]="payment.selectEarlyAdopterAgreementSigned$ | ngrxPush">
            </mat-checkbox>
            <button mat-button color="primary" (click)="learnMoreEarlyAdopter()">
              <span class="early-adopter-agreement-link"> I Agree to Early Adopter Terms </span>
            </button>
          </div>

          <ng-container *ngIf="!hasSubscription">
            <div class="checkout-btn">
              <!--              <ng-container *ngrxLet="stripeCoupon$; let stripeCoupon">-->
              <!--                <ng-container *ngIf="stripeCoupon?.stripeCoupon !== null">-->
              <!--                  <div class="push-bottom-20">-->
              <!--                    {{ stripeCoupon.stripeCouponMessage }} with code &nbsp;-->
              <!--                    <span class="accent font-bold">{{-->
              <!--                      stripeCoupon.stripeCoupon-->
              <!--                    }}</span>-->
              <!--                  </div>-->
              <!--                </ng-container>-->
              <!--              </ng-container>-->

              <button mat-flat-button color="primary" (click)="payment.onCheckout(false)"
                [disabled]="payment.checkoutDisabled$ | ngrxPush">
                CHECKOUT
              </button>
            </div>
            <div class="mat-small checkout-description">
              You will be redirected to the checkout site.
            </div>
          </ng-container>

          <ng-container *ngIf="hasSubscription">
            <button mat-flat-button class="checkout-btn" color="primary" (click)="payment.onUpdate()"
              [disabled]="payment.checkoutDisabled$ | ngrxPush">
              UPDATE
            </button>
          </ng-container>
        </div>
      </div>
    </mat-step>

    <mat-step *ngIf="!(platform.IOS || platform.ANDROID) && hasSubscription">
      <ng-template matStepLabel>download</ng-template>
      <div class="mat-h2">Thank you for subscribing to Spout!</div>
      <spt-download-spout [showBackground]="false"></spt-download-spout>
    </mat-step>
  </mat-horizontal-stepper>
</ng-container>